import React, { useEffect } from "react";

export default function InfoLayout({ title, subtitle, docTitle, children }) {
  useEffect(() => {
    document.title = `${docTitle || title} — CiteQR`;
  }, [title, docTitle]);

  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8 fade-in">
      <h1 className="text-3xl font-bold tracking-tight text-slate-900 md:text-4xl">{title}</h1>
      {subtitle && <p className="mt-3 text-base leading-relaxed text-slate-600">{subtitle}</p>}
      <div className="mt-8 space-y-6 text-sm leading-relaxed text-slate-700">{children}</div>
    </div>
  );
}

export function Sec({ heading, children }) {
  return (
    <section>
      <h2 className="text-lg font-semibold text-slate-900">{heading}</h2>
      <div className="mt-2 space-y-3">{children}</div>
    </section>
  );
}
